import { STARGATE_ROUTES } from 'config/application-routes';

import type { Settings } from 'core/domains';

const routeErrorBase = {
  component: 'Error',
  documentType: '',
  isPrivate: false,
};

const routePageBuilder = {
  component: 'PageBuilder',
  isHomepage: false,
  isPrivate: true,
  isMainHeader: true,
  isSearchPage: false,
};

export const StargateStaticRoutes = [
  {
    component: 'ResaleIntentionPage',
    documentType: '',
    isPrivate: true,
    path: STARGATE_ROUTES.RESALE_INTENTION,
    isMainHeader: true,
  },
  {
    component: 'ExtendedCaptationPage',
    documentType: '',
    isPrivate: true,
    path: STARGATE_ROUTES.EXTENDED_CAPTATION,
    isMainHeader: true,
  },
  {
    ...routeErrorBase,
    path: STARGATE_ROUTES.ERROR_500,
    canBlockedResellerAccess: true,
  },
  {
    ...routeErrorBase,
    path: STARGATE_ROUTES.SPECIAL_PAYMENT_ERROR,
    canBlockedResellerAccess: true,
  },
  {
    ...routeErrorBase,
    path: STARGATE_ROUTES.ERROR_GENERIC,
    canBlockedResellerAccess: true,
  },
  {
    ...routeErrorBase,
    path: STARGATE_ROUTES.ERROR_401,
    canBlockedResellerAccess: true,
  },
  {
    ...routeErrorBase,
    path: STARGATE_ROUTES.ERROR_403,
    isMainHeader: true,
    canBlockedResellerAccess: true,
  },
  {
    component: 'ErrorVDF',
    documentType: '',
    isPrivate: false,
    path: STARGATE_ROUTES.ERROR_VDF,
    isMainHeader: true,
    canBlockedResellerAccess: true,
  },
  {
    ...routeErrorBase,
    path: STARGATE_ROUTES.ERROR_PROCESS,
  },
  {
    component: 'Login',
    documentType: '',
    isPublic: true,
    isPrivate: false,
    path: STARGATE_ROUTES.LOGIN || '/login/',
    isMainHeader: false,
  },
  {
    component: 'Faq',
    documentType: '',
    isPublic: true,
    isPrivate: false,
    path: STARGATE_ROUTES.FAQ,
    isMainHeader: false,
  },
  {
    component: 'Logout',
    documentType: '',
    isPublic: true,
    path: STARGATE_ROUTES.LOGOUT,
    isMainHeader: false,
  },
  {
    component: 'PageGifts',
    documentType: '',
    isHomepage: false,
    isPrivate: true,
    isMainHeader: false,
    isSearchPage: false,
    name: 'Gifts',
    path: STARGATE_ROUTES.GIFTS,
  },
  {
    component: 'PageProductsByTag',
    documentType: '',
    isHomepage: false,
    isPrivate: true,
    isMainHeader: true,
    isSearchPage: false,
    name: 'ProductsByTag',
    path: STARGATE_ROUTES.PRODUCTS_BY_TAG,
  },
  {
    component: 'PageEmptyRecommendation',
    documentType: '',
    isHomepage: false,
    isPrivate: true,
    isMainHeader: true,
    isSearchPage: false,
    name: 'PageEmptyRecommendation',
    path: STARGATE_ROUTES.EMPTY_RECOMMENDATION,
  },
  {
    component: 'PageTapume',
    documentType: '',
    isPrivate: false,
    path: STARGATE_ROUTES.TAPUME,
    isMainHeader: false,
  },
  {
    isMainHeader: true,
    isPrivate: true,
    documentType: 'page-departments',
    isHomepage: true,
    name: 'Departamentos',
    path: '/departamentos',
    component: 'PageDepartments',
  },
  {
    component: 'PageCategory',
    documentType: '',
    isHomepage: false,
    isPrivate: true,
    isMainHeader: true,
    isSearchPage: false,
    name: 'PageCategory',
    path: '/departamentos/:department',
  },
  {
    ...routePageBuilder,
    documentType: 'broken_type',
    isMainHeader: false,
    name: 'Erro ao processar descontos',
    path: STARGATE_ROUTES.ERROR_PROCESS,
  },
  {
    ...routePageBuilder,
    documentType: 'page-combo',
    name: 'Combo personalizado',
    path: STARGATE_ROUTES.COMBO,
  },
  {
    ...routePageBuilder,
    documentType: 'page-combo-error',
    isMainHeader: false,
    name: 'Combo sem estoque',
    path: STARGATE_ROUTES.ERROR_COMBO,
  },
  {
    component: 'PageCheckout',
    isHomepage: false,
    isPrivate: true,
    isMainHeader: false,
    isSearchPage: false,
    name: 'Checkout',
    path: STARGATE_ROUTES.CHECKOUT,
  },
  {
    component: 'PageOrderSuccess',
    documentType: 'page-confirmation',
    isHomepage: false,
    isPrivate: true,
    isMainHeader: false,
    isSearchPage: false,
    name: 'Confirmação de compra',
    path: STARGATE_ROUTES.CHECKOUT_CONFIRMATION,
  },
  {
    ...routePageBuilder,
    documentType: 'page-categories',
    name: 'Departamento',
    path: STARGATE_ROUTES.DEPARTMENT,
  },
  {
    component: 'PageSearch',
    documentType: '',
    isHomepage: false,
    isPrivate: true,
    isMainHeader: true,
    isSearchPage: true,
    name: 'Resultado da Busca',
    path: STARGATE_ROUTES.SEARCH,
  },
  {
    component: 'PageProductDetail',
    isHomepage: false,
    isPrivate: true,
    isMainHeader: true,
    isSearchPage: false,
    name: 'Página de detalhe do produto',
    path: STARGATE_ROUTES.PRODUCT_DETAIL,
  },
  {
    component: 'RecoverPassword',
    documentType: '',
    isPublic: true,
    isPrivate: false,
    path: STARGATE_ROUTES.RECOVER_PASSWORD,
    isMainHeader: false,
  },
  {
    component: 'RecoverPasswordEmail',
    documentType: '',
    isPublic: true,
    isPrivate: false,
    path: STARGATE_ROUTES.RECOVER_PASSWORD_EMAIL,
    isMainHeader: false,
  },
  {
    component: 'RecoverPasswordEmailSuccess',
    documentType: '',
    isPublic: true,
    isPrivate: false,
    path: STARGATE_ROUTES.RECOVER_PASSWORD_EMAIL_SUCCESS,
    isMainHeader: false,
  },
  {
    component: 'CartPage',
    isHomepage: false,
    isPrivate: true,
    isMainHeader: false,
    isSearchPage: false,
    name: 'Carrinho',
    path: STARGATE_ROUTES.CART,
  },
] as Settings['data']['routes'];

export const staticRoutes = [...StargateStaticRoutes] as Settings['data']['routes'];
